/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-FocusZoneTabbableExample .ms-Row{display:block;margin:5px}.ms-FocusZoneTabbableExample-textField{display:inline-block;width:300px}\n"}]);